import React from "react";
import { Alert, AppLayout, Flashbar, FormField, Select, Button } from "@amzn/awsui-components-react";
import SideBar from "../../navigation/sidebar.js";
import { getApiUrl, verify, getOptions } from "../../auth/login.js";
import "./home.css";
import { fetch_retry } from "../../util/fetch-retry";

class Accounts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accounts: [],
            selected: null,
            loading: true,
            showAlert: false,
            alert: "",
            showSuccess: false,
            success: "",
        };
    }

    getAccounts(callback) {
        verify(async () => {
            const opts = await getOptions();
            const apiUrl = await getApiUrl();
            opts.method = "GET";
            const user = localStorage.getItem("userId");

            // Our lambda function times out when cold.
            // Since this is called to initiate the sandbox experience, this must be retried until the lambda is up.
            fetch_retry(`${apiUrl}/get_aws_accounts_for_user_alias?user_alias=${user}`, opts, 4)
                .then((res) => {
                    if (!res.ok) {
                        this.showAlert(`${res.status} There is an internal server error. Please try again later.`);
                    }

                    return res.json();
                })
                .then((data) => {
                    if (data.awsAccountInfos === undefined) {
                        callback([]);
                    } else {
                        callback(data.awsAccountInfos);
                    }
                })
                .catch(console.log);
        });
    }

    selectAccount(account, callback) {
        let successMessage = "";
        let errorMessage = "";
        switch (successMessage) {
            case "start_sandbox":
                successMessage = "Sandbox is starting.";
                errorMessage = "There was a problem with starting your sandbox. Please try again later.";
                break;
            case "stop_sandbox":
                successMessage = "Sandbox is stopping.";
                errorMessage = "There was a problem with stoppign your sandbox. Please try again later.";
                break;
            case "delete_sandbox":
                successMessage = "Sandbox is being deleted.";
                errorMessage = "There was a problem with deleting your sandbox. Please try again later.";
                break;
            default:
                successMessage = "Success";
                errorMessage = "There was a problem. Please try again later.";
        }
        verify(async () => {
            const opts = await getOptions();
            opts.method = "GET";
            const user = localStorage.getItem("userId");
            fetch((await getApiUrl()) + `/list_sandboxes?user_alias=${user}&aws_account_id=${account}`, opts)
                .then((res) => {
                    if (res.ok) {
                        localStorage.setItem("account", account);
                        this.showSuccess(successMessage);
                    } else {
                        // 500 Error does not return an error message
                        if (res.status === 500) {
                            this.showAlert(errorMessage);
                        } else {
                            this.activate(account);
                        }
                    }
                })
                .catch();
        });
    }

    activate(account) {
        const errorMessage = "There was a problem selecting your account. Please try again.";
        const successMessage = "Account successfully selected";
        verify(async () => {
            const opts = await getOptions();
            opts.method = "POST";
            const user = localStorage.getItem("userId");
            const body = JSON.stringify({
                awsAccountId: account,
                userAlias: user,
            });
            opts.body = body;
            fetch((await getApiUrl()) + `/activate_user`, opts)
                .then((res) => {
                    if (res.ok) {
                        this.showSuccess(successMessage);
                        localStorage.setItem("account", account);
                        this.componentDidMount();
                    } else {
                        // 500 Error does not return an error message
                        if (res.status === 500) {
                            this.showAlert(errorMessage);
                        } else {
                            return res.json();
                        }
                    }
                })
                .then((resBody) => {
                    if (resBody === undefined) {
                        return;
                    }
                    if (resBody.message !== undefined && resBody.message !== null) {
                        this.showAlert(resBody.message);
                    } else {
                        this.showAlert(errorMessage);
                    }
                })
                .catch(this.showAlert(errorMessage));
        });
    }

    showAlert(message) {
        this.setState({
            showAlert: true,
            alert: message,
            showSuccess: false,
            success: "",
        });
    }

    showSuccess(message) {
        this.setState({
            showAlert: false,
            alert: "",
            showSuccess: true,
            success: message,
        });
    }

    async componentDidMount() {
        this.getAccounts((awsAccounts) => {
            awsAccounts = awsAccounts.map((curr) => ({
                id: curr.awsAccountId,
                label: curr.awsAccountName,
            }));
            let selectedAccount = null;
            const localAccount = localStorage.getItem("account");
            if (localAccount) {
                selectedAccount = awsAccounts.filter((obj) => {
                    return obj.id === localAccount;
                });
                if (selectedAccount.length !== 1) {
                    selectedAccount = null;
                } else {
                    selectedAccount = selectedAccount[0];
                }
            }
            this.setState({
                accounts: awsAccounts,
                selected: selectedAccount,
                loading: false,
            });
        });
    }

    render() {
        return (
            <div className="awsui-util-container awsui-util-mb-n">
                <h2>Select an AWS Account</h2>
                {this.state.showAlert || this.state.showSuccess ? (
                    <Flashbar
                        items={[
                            {
                                type: this.state.showAlert ? "error" : "success",
                                content: this.state.showAlert ? this.state.alert : this.state.success,
                                dismissible: true,
                                onDismiss: () =>
                                    this.setState({
                                        showAlert: false,
                                        alert: "",
                                        showSuccess: false,
                                        success: "",
                                    }),
                            },
                        ]}
                    />
                ) : null}

                <Alert visible={!localStorage.getItem("account")}>Select an AWS account to continue.</Alert>

                <FormField stretch={true} label="AWS Account" className="awsui-util-d-b">
                    <Select
                        selectedLabel="Selected"
                        options={this.state.accounts}
                        selectedOption={this.state.selected}
                        empty="No options"
                        placeholder="Choose an account"
                        className="awsui-util-mb-xl"
                        ariaRequired={true}
                        loading={this.state.loading}
                        onChange={({ detail }) => {
                            this.setState({ selected: detail.selectedOption });
                            this.selectAccount(detail.selectedOption.id);
                        }}
                    />
                </FormField>
            </div>
        );
    }
}

const Content = () => (
    <div id="Home">
        <div className="awsui-grid awsui-util-p-s">
            <div id="home-header" className="awsui-row">
                <div className="col-xxs-12">
                    <div className="awsui-row">
                        <div
                            id="home-header-title"
                            className="col-xxs-10 offset-xxs-1 col-s-6 col-l-5 offset-l-2 col-xl-6"
                        >
                            <div className="awsui-text-large">
                                <h1 className="awsui-text-large">
                                    <strong>Secure AI Sandbox</strong>
                                </h1>
                                <div>Manage and create your Secure AI Sandboxes</div>
                            </div>
                            <p>
                                Secure AI Sandbox is a consolidated environment for ad-hoc feature development, model
                                experiment and rule testing without security concern.
                            </p>
                        </div>
                        <div className="col-xxs-10 offset-xxs-1 col-s-4 offset-s-0 col-l-3 col-xl-2">
                            <Accounts />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="awsui-grid awsui-util-p-s">
            <div id="home-body" className="awsui-row">
                <div className="col-xxs-12">
                    <div className="awsui-row">
                        <div className="col-xxs-10 offset-xxs-1 col-s-6 col-l-5 offset-l-2 col-xl-6">
                            <div className="awsui-util-container">
                                <div className="awsui-text-large">
                                    <h2 className="awsui-text-large">What is Secure AI Sandbox?</h2>
                                    <p>
                                        Secure AI Sandbox is a secure virtual machine which allows the client to do
                                        offline experiments with approved ML development software stacks pre-installed
                                        on the machine by leveraging the power of AWS deep learning support. We will
                                        also leverage the power of container technology to provide a smooth integration
                                        with Core services. Sandbox will audit and control the access to Core ML
                                        Services (CMLS) owned data lake, Modelling Data Service (MDS), as well as Amazon
                                        internal data exchange services such as EDX or Andes. Sandbox users will be able
                                        to export machine learning artifact and experiment results to CMLS owned ML
                                        pipeline by seamlessly integrating with existing CTPS Core ML products including
                                        On-The Fly (OTF) and Model management Service (MMS). Sandbox takes care of all
                                        maintenance efforts including patching, host replacement, and addressing policy
                                        engine risks. It also provides an option to back up the workspace on a regular
                                        basis to prevent loss of data due to host failure.
                                    </p>
                                </div>
                            </div>

                            <div className="awsui-util-container">
                                <div className="awsui-text-large">
                                    <h2 className="awsui-text-large">Who will it benefit?</h2>
                                    <p>
                                        Secure AI Sandbox aims to help all machine learning scientists with their daily
                                        needs for offline analysis, development, and research. It gives SDEs a better
                                        way to audit the data access and maintain tools needed by ML scientists and
                                        finally Amazon customers also benefit from it as it makes their confidential
                                        data more secure. Any ML scientist who has one of the following need should
                                        consider the use of Secure AI Sandbox (a) Need to access the data and manually
                                        build a model with Modeling Data Service (MDS) data (b) Need to do an experiment
                                        for new On The Fly (OTF) Compute feature logic(s) (c) Need to have a reliable
                                        work space with popular machine learning framework installed.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxs-10 offset-xxs-1 col-s-4 offset-s-0 col-l-3 col-xl-2">
                            <div className="awsui-util-container">
                                <div className="awsui-util-container-header">
                                    <h2>Help</h2>
                                </div>
                                <p>
                                    The Secure AI Sandbox is run by the CMLS team in CTPS. For more information on what
                                    we do click below.
                                </p>
                                <Button href="https://w.amazon.com/bin/view/CMLS/Overview/" variant="primary">
                                    CMLS Overview
                                </Button>
                                <p>Need help? Submit a SIM or sign up for office hours with the link below.</p>
                                <Button href="https://w.amazon.com/bin/view/CMLS/ContactUs/" variant="primary">
                                    Contact Us
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

function Home() {
    return (
        <AppLayout
            className="awsui-util-no-gutters"
            content={<Content />}
            navigation={<SideBar activeHref="/" />}
            navigationOpen={true}
            toolsHide={true}
            headerSelector="#harmony-navbar"
        />
    );
}

export default Home;
